import Axios, { InternalAxiosRequestConfig } from 'axios';
import { env } from 'src/config/env';
import { getStorageItem } from 'src/lib/localStorage';
import { StorageKeys } from 'src/enums/StorageKeys.enum';
import { logout } from 'src/utils';

//* Attach auth headers to requests here
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  config.headers.Accept = 'application/json';

  //! This is for testing purposes
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Access-Control-Allow-Methods'] =
    'GET, POST, PUT, DELETE, OPTIONS';

  //* Unauthenticated paths
  //! Please edit these as necessary
  const nonAuthPaths = ['/'];
  const currentApiPath = config.url ?? '';
  if (nonAuthPaths.includes(currentApiPath)) {
    return config;
  }

  //* Authenticated paths
  const jwt = getStorageItem(StorageKeys.token);
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
}

export const api = Axios.create({
  baseURL: env.API_BASE_URL + '/admin',
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('api error.response', error?.response);

    if (error?.message === 'Network Error') {
      return Promise.reject(error);
    }

    //* This is the redirect logic for production
    if (error.response?.status === 401) {
      logout();
    }

    if (error.response?.status === 500) {
      return Promise.reject({ message: 'Unexpected API error' });
    }

    if (error.response?.status === 404) {
      return Promise.reject({
        message: `Not found: ${error.config.method.toUpperCase()} ${
          error.config.url
        }`,
      });
    }

    if (typeof error.response?.data?.error === 'string') {
      return Promise.reject({ message: error.response.data.error });
    }

    return Promise.reject({
      message: 'Something went wrong...',
    });
  }
);
